import { CacheUpdateState } from "../../types";
import { typedAction } from "../helpers";
import { SIGNAL_CACHE_UPDATE } from "./actionTypes";

const initialState: CacheUpdateState = { toggle: false };

export const signalCacheUpdate = () => {
    return typedAction(SIGNAL_CACHE_UPDATE);
}

type CacheUpdateAction = ReturnType<typeof signalCacheUpdate>;

export function cacheUpdateReducer(
    state = initialState,
    action: CacheUpdateAction
): CacheUpdateState {
    switch (action.type) {
        case SIGNAL_CACHE_UPDATE:
            return { toggle: !state.toggle };
        default:
            return state;
    }
}